export default "__VITE_ASSET__CvTSOkSX__"